module.exports = __webpack_public_path__ + "static/media/down-arrow.8bc9e02c.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/down-arrow.svg
// module id = 1723
// module chunks = 0